// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qUXHj","box":"styles_box__zqWDj","icon":"styles_icon__D2THb"};